export const userInfo = (state) => {
    return state.userInfo
}

export const isMobile = (state) => {
    return state.isMobile
}

export const theme = (state) => {
    return state.theme
}

export const layout = (state) => {
    return state.layout
}


export const multipage = (state) => {
    return state.multipage
}

// export const systemName = (state) => {
//     return state.systemName
// }

export const fixedHeader = (state) => {
    return state.fixedHeader
}

export const fixedSidebar = (state) => {
    return state.fixedSidebar
}

export const routes = (state) => {
    return state.routes
}

export const role = (state) => {
    return state.role
}

export const systemName = (state) => {
    return state.systemName
}

export const copyright = (state) => {
    return state.copyright
}

export const licenseNumber = (state) => {
    return state.licenseNumber
}

export const isInit = (state) => {
    return state.isInit
}

export const loginUrl = (state) => {
    return state.loginUrl
}
export const registerUrl = (state) => {
    return state.registerUrl
}
export const supervisionUrl = (state) => {
    return state.supervisionUrl
}
export const marginAmountStatistics = (state) => {
    return state.marginAmountStatistics
}
export const technicalSupport = (state) => {
    return state.technicalSupport
}

export const showComplaints = (state) => {
    return state.showComplaints
}
export const showCreditPublicity = (state) => {
    return state.showCreditPublicity
}
export const showEnterpriseCenter = (state) => {
    return state.showEnterpriseCenter
}
export const showHandlingGuide = (state) => {
    return state.showHandlingGuide
}
export const showIndex = (state) => {
    return state.showIndex
}
export const showOrgPublicity = (state) => {
    return state.showOrgPublicity
}
export const showPoliciesRegulations = (state) => {
    return state.showPoliciesRegulations
}
export const showSupervisionCenter = (state) => {
    return state.showSupervisionCenter
}
export const showPolicyVerification = (state) => {
    return state.showPolicyVerification
}

export const domainNameTitle = (state) => {
    return state.domainNameTitle
}

export const version = (state) => {
    return state.version
}